import { type BlaBlaCarProviderOffer, type ProviderOffer } from "../../../../../types/dtos/api/sales/provider-offer.dto";
import { isFiniteNonNegativeNumber } from "../helpers/OfferPricingNumber.helper";
import { resolveBookingUrlFromBookingUrls } from "../helpers/OfferPricingUrl.helper";
import { type OfferPricingEvaluationContext, type ProviderPricingEvaluation } from "../OfferPricing.types";
import { BaseOfferPricingProvider } from "../OfferPricingProvider.contract";

export class BlablacarOfferPricingProvider extends BaseOfferPricingProvider {

    /**
     * Creates the BlaBlaCar pricing provider plugin.
     */
    public constructor() {
        super( "blablacar" );
    }

    /**
     * Normalizes BlaBlaCar price and booking URL values.
     *
     * @param _ Segment context (unused for this provider).
     * @param providerOffer Raw provider payload.
     * @returns Normalized provider evaluation.
     */
    public evaluate( _: OfferPricingEvaluationContext, providerOffer: ProviderOffer ): ProviderPricingEvaluation {
        const typedOffer = providerOffer as BlaBlaCarProviderOffer;
        const price = isFiniteNonNegativeNumber( typedOffer.price ) ? typedOffer.price : null;
        const bookingUrl = resolveBookingUrlFromBookingUrls( typedOffer.bookingUrls );

        return {
            "providerKey":  typedOffer.provider,
            "providerName": this.getProviderLabel(),
            price,
            bookingUrl,
        };
    }

}

export const blablacarOfferPricingProviderPlugin = new BlablacarOfferPricingProvider();
